import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/internal/BehaviorSubject';
import { StoreTokenService } from './store-token.service';

@Injectable({
  providedIn: 'root',
})

export class StoreAuthStateService {
  private userState = new BehaviorSubject<boolean>(this.token.isLoggedIn()!);
  userAuthState = this.userState.asObservable();
  constructor(public token: StoreTokenService) {}
  setAuthState(value: boolean) {
    this.userState.next(value);
  }
}